import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent, sendScreenEvent } from 'services/analytics';

// https://data-portal.internal.atlassian.com/analytics/registry/84833
const trackBadgeCardClick = (
  badgeTitle: string,
  badgeType: string,
  isPersonalView: boolean,
) => {
  sendUIEvent({
    source: SCREEN_NAME.BADGES,
    action: 'clicked',
    actionSubject: 'card',
    actionSubjectId: 'unifiedProfileBadgeCard',
    attributes: {
      badgeTitle: badgeTitle.substring(0, 50),
      badgeType,
    },
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71731
const trackProfileScreenView = (isPersonalView: boolean) => {
  sendScreenEvent({
    screenName: SCREEN_NAME.PROFILE,
    isPersonalView,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/71735
const trackGroupsScreenView = (isPersonalView: boolean) => {
  sendScreenEvent({
    screenName: SCREEN_NAME.GROUPS,
    isPersonalView,
  });
};

export { trackBadgeCardClick, trackProfileScreenView, trackGroupsScreenView };
